import { render, staticRenderFns } from "./SettingsEmails.vue?vue&type=template&id=867725a4"
import script from "./SettingsEmails.vue?vue&type=script&lang=js"
export * from "./SettingsEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports